import { useCallback } from 'react';
import { usePartnerDataClient } from '../api/use-partner-data-client';
import { AssessmentMatch } from '../domain/types';
import { useAsyncResource } from './use-async-resource';

export interface UseIngestionAssessmentsReturn {
  assessments: AssessmentMatch[];
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
}

const NO_ASSESSMENTS: AssessmentMatch[] = [];

/**
 * Gatekeeper assessment verdicts for an ingestion — which configurations were
 * evaluated against the file and whether each matched. Not paginated.
 */
export const useIngestionAssessments = (
  eventId: string,
): UseIngestionAssessmentsReturn => {
  const client = usePartnerDataClient();

  const fetchAssessments = useCallback(
    async () => (await client.getAssessments(eventId)).items,
    [client, eventId],
  );

  const { data, isLoading, hasError, refetch } = useAsyncResource<
    AssessmentMatch[]
  >(fetchAssessments, NO_ASSESSMENTS);

  return { assessments: data, isLoading, hasError, refetch };
};
